export const QUES_COMPONENT_TYPES = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  SCALE: 'scalebar',
  INPUT: 'input',
  MULTIRADIO: 'multiRadio',
  EXECUTION: 'execution',
  SCALEWITHINPUT: 'scaleWithInput',
  RADIOWITHINPUT: 'radioWithInput',
};
